import React from "react";

class VoteBanner extends React.Component {
    render() {
        return (
            <section
                className="banner banner-flex promo site-only full-banner-link"
                data-callback="accounts/hide-banner/VOTE_2020"
                data-banner-show-anonymous="true"
                data-banner-key="lingo"
            >
                <div className="banner-grid row">
                    <a
                        className="no-decoration"
                        href="https://vote.thenounproject.com"
                        target="_blank"
                    >
                        <span className="info">
                            <span style={{"textDecoration": "underline"}}>Help get out the vote</span>&nbsp;with Noun Project + Vote.org
                        </span>
                    </a>
                    <span
                        className="dismiss-banner ui_close"
                        onClick={this.props.bannerDismiss}
                        title="Dismiss banner"
                    />
                </div>
            </section>
        );
    }
}

export default VoteBanner;
